import React from "react";
import { Container, makeStyles, Paper, Typography } from "@material-ui/core";
import SEO from "./SEO";
import { Footer } from "./Footer";
import clsx from "clsx";
import { GridOn } from "@material-ui/icons";
import Helmet from "react-helmet";
import {Disclaimer} from "./styled";

const useStyles = makeStyles(theme => ({
  heading: {
    textTransform: "uppercase",
    fontSize: '2.4rem',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.4rem',
    }
  },
  responsiveHeading: {
    fontSize: '1.8rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    }
  },
  paper: {
    padding: theme.spacing(4)
  },
  arrows: {
    overflow: 'hidden',
    "&::before": {
      backgroundColor: '#006171',
      content: '""',
      display: 'block',
      width: '20vw',
      height: '20vw',
      position: 'absolute',
      top: '50%',
      transform: `translateY(-50%) rotate(45deg)`,
      zIndex: -1,
      opacity: 0.8,
      right: `calc(100% - 10vw)`
    },
    "&::after": {
      backgroundColor: '#006171',
      content: '""',
      display: 'block',
      width: '20vw',
      height: '20vw',
      position: 'absolute',
      top: '50%',
      left: `calc(100% - 10vw)`,
      transform: `translateY(-50%) rotate(45deg)`,
      zIndex: -1,
      opacity: 0.8,
    }
  },
  logo: {
    padding: '0px',
    fontSize: '2.2rem',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  title: {
    fontFamily: "Teko, san-serif",
    textTransform: "uppercase",
    maxHeight: '52px',
    fontSize: '2.5rem',
    fontWeight: "700",
    marginLeft: theme.spacing(0.5),
    color: theme.palette.primary.main,
    lineHeight: 'inherit',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.6rem',
    },
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 20px',
    [theme.breakpoints.down("xs")]: {
      flexDirection: 'column-reverse',
      padding: '8px 20px 4px 20px'
    },
  },
}));

export const Layout = ({title, phone = undefined, heading, children, hasPadding = false, referral, name }) => {
  const classes = useStyles();
  return (
    <>
      <Helmet>
        <script src="https://analytics.growthhub.com/analytics.js" defer async />
      </Helmet>
      <SEO title={title}/>
      {phone ? <Disclaimer phone={phone} /> : null}
      <div>
        <div id="app-container">
          <Container maxWidth="md">
            <Paper elevation={4} className={`${hasPadding ? classes.paper : ''}`} style={{ marginTop: '12px'}}>

              <div className={classes.headingContainer}>
                <Typography variant="subtitle1" className={heading.length >= 30 ? clsx(classes.heading, classes.responsiveHeading) : classes.heading} color="primary">
                  {heading}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <GridOn fontSize="large" className={classes.logo}/>
                  <Typography variant="h3" className={classes.title}>
                    SALEGRID
                  </Typography>
                </div>
              </div>

              <div className={classes.arrows}>
                {children}
              </div>
            </Paper>
            <Footer name={name} referral={referral}/>
          </Container>
        </div>
      </div>
    </>
  );
};
